export const DEFAULT_TIMEOUT = 30000; // 30 seconds

export const MICRO_SERVICE_ROUTES = {
	NOTIFICATIONS: "/notifications",
	USERS: "/users",
};

export const API_ROUTES = {
	AUTH: `${MICRO_SERVICE_ROUTES.USERS}/auth/v1`,
	INSTITUTES: "/institutes",
	APPLICATIONS: "/applications",
	TRACK_APPLICATIONS: "/track-applications",
	COURSES: "/courses",
	USERS: `${MICRO_SERVICE_ROUTES.USERS}/users/v1`,
	DISTRICT_BY_DIVISION: "/districts-by-division",
	LOCATIONS: "/locations",
	DIVISIONS: "/divisions",
	NOTIFICATIONS: `${MICRO_SERVICE_ROUTES.NOTIFICATIONS}/notifications`,
} as const;

export const API_PATHS = {
	AUTH: {
		SIGN_IN: "/login",
		SIGN_UP: "/employer/register",
		VERIFY_EMAIL: "/verify-email",
		FORGOT_PASSWORD: "/forgot-password",
		RESET_PASSWORD: "/reset-password",
		CHANGE_PASSWORD: "/change-password",
		SET_PASSWORD: "/reset-password",
		VERIFY_OTP: "/verify-otp",
		RESEND_OTP: "/resend-otp",
	},
	USER: {
		GET_PROFILE: "/profile",
		PROFILE_IMAGE_UPLOAD_URL: "/profile/image/upload-url",
		PROFILE_IMAGE_UPDATE: "/profile/image",
		EMPLOYER_UPDATE: "/employer/update",
	},
	INSTITUTES: {
		APPLICATIONS: {
			INSTITUTE_DETAIL: "/applications/institute-detail",
			BUILDING_DETAIL: "/applications/building-detail",
			APPLICATION_ATTACHMENT: "/applications/application-attachment",
		},
		ORGANIZATION_TYPE: "/organization-type",
		PROVINCE: "/province",
		DIVISION: "/division",
		DISTRICT: "/district",
		CITY: "/city",
		TEHSIL: "/tehsil",
		UNION_COUNCIL: "/union-council",
		NATIONAL_ASSEMBLY: "/national-assembly",
		PROVISIONAL_ASSEMBLY: "/provisional-assembly",
		FACILITY_TYPES: "/institutes/facility-types",
		ATTACHMENT_TYPES: "/institutes/attachment-types",
		GET_ATTACHMENT: "/attachments",
		FILE_UPLOAD_URL: "/attachments/upload",
		COURSE_STREAM: "/course-stream",
		COURSE_LIST: "/course",
		QUALIFICATION: "/qualification",
		DESIGNATION: "/designation",
		COURSE_LABS: "/labs/courses",
		ATTACHMENT_UPLOAD: "/attachments/upload",
		APPLICATION_COURSE: "/applications/application-course",
               JOB_CREATE: "/job/create",
               JOBS: "/job",
               JOB_DETAIL: "/job",
               JOB_CLOSE: "/job",
		JOB_CATEGORIES: "/job-category",
		MATCH_CANDIDATES: "/job-applications/match-candidates",
		AI_CANDIDATES: "/job-applications/ai-candidates",
		SECTORS: "/sector",
		JOB_SKILLS: "/skill",
		EMPLOYMENT_TYPES: "/employment-type",
		EXPERIENCE: "/experience",
		TRADES: "/course",
	},
	E_CHALLAN_SUMMARY: {
		E_CHALLANS: "/e-challan",
	},
	E_CHALLAN_STATUS: {
		E_CHALLAN_STATUS: "/e-challan-status",
	},
	NOTIFICATIONS: {
		READ: "/read",
		STREAM: "/user/{id}/stream",
	},
	COURSES: {
		EQUIPMENT: "/equipment",
	},
};

export const SERVER_ROUTES = {
	AUTH: {
		SIGN_IN: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_IN,
		SIGN_UP: API_ROUTES?.AUTH + API_PATHS?.AUTH?.SIGN_UP,
		VERIFY_EMAIL: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_EMAIL,
		FORGOT_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.FORGOT_PASSWORD,
		RESET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.RESET_PASSWORD,
		CHANGE_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.CHANGE_PASSWORD,
		SET_PASSWORD: API_ROUTES.AUTH + API_PATHS.AUTH.SET_PASSWORD,
		VERIFY_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.VERIFY_OTP,
		RESEND_OTP: API_ROUTES.AUTH + API_PATHS.AUTH.RESEND_OTP,
	},
	USER: {
		GET_PROFILE: API_ROUTES.AUTH + API_PATHS.USER.GET_PROFILE,
		PROFILE_IMAGE_UPLOAD_URL: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPLOAD_URL,
		PROFILE_IMAGE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.PROFILE_IMAGE_UPDATE,
		PROFILE_UPDATE: API_ROUTES.USERS + API_PATHS.USER.GET_PROFILE,
		EMPLOYER_UPDATE: API_ROUTES.AUTH + API_PATHS.USER.EMPLOYER_UPDATE,
	},
	INSTITUTES: {
		APPLICATIONS: {
			INSTITUTE_DETAIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.INSTITUTE_DETAIL,
			BUILDING_DETAIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.BUILDING_DETAIL,
			APPLICATION_ATTACHMENT: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATIONS.APPLICATION_ATTACHMENT,
		},
		ORGANIZATION_TYPE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ORGANIZATION_TYPE,
		PROVINCE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.PROVINCE,
		DIVISION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DIVISION,
		DISTRICT: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DISTRICT,
		CITY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.CITY,
		TEHSIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.TEHSIL,
		UNION_COUNCIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.UNION_COUNCIL,
		NATIONAL_ASSEMBLY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.NATIONAL_ASSEMBLY,
		PROVISIONAL_ASSEMBLY: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.PROVISIONAL_ASSEMBLY,
		FACILITY_TYPES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.FACILITY_TYPES,
		ATTACHMENT_TYPES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ATTACHMENT_TYPES,
		GET_ATTACHMENT: (filename: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.GET_ATTACHMENT}/${encodeURIComponent(filename)}`,
		FILE_UPLOAD_URL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.FILE_UPLOAD_URL,
		COURSE_STREAM: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.COURSE_STREAM,
		COURSE_LIST: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.COURSE_LIST,
		QUALIFICATION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.QUALIFICATION,
		DESIGNATION: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.DESIGNATION,
		COURSE_LABS: (courseId: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.COURSE_LABS}/${courseId}/labs`,
		ATTACHMENT_UPLOAD: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.ATTACHMENT_UPLOAD,
		APPLICATION_COURSE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.APPLICATION_COURSE,
               JOB_CREATE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.JOB_CREATE,
               JOBS: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.JOBS,
               JOB_DETAIL: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.JOB_DETAIL,
               JOB_CLOSE: (jobUuid: string) => `${API_ROUTES.INSTITUTES}${API_PATHS.INSTITUTES.JOB_CLOSE}/${jobUuid}`,
               JOB_APPLICATIONS: (jobId: string, page: number, limit: number) => 
                   `${API_ROUTES.INSTITUTES}/job/${jobId}/applications?page=${page}&limit=${limit}`,
               APPLICATION_DETAIL: (applicationUuid: string) => 
                   `${API_ROUTES.INSTITUTES}/job-applications/${applicationUuid}`,
               APPLICATION_REJECT: (applicationUuid: string) => 
                   `${API_ROUTES.INSTITUTES}/job-applications/${applicationUuid}/reject`,
               RESCHEDULE_INTERVIEW: (applicationUuid: string) => 
                   `${API_ROUTES.INSTITUTES}/job-applications/${applicationUuid}/reschedule-interview`,
               EMPLOYEE_DETAIL: (employeeUuid: string) => 
                   `${API_ROUTES.INSTITUTES}/job-applications/${employeeUuid}`,
               JOB_CATEGORIES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.JOB_CATEGORIES,
               MATCH_CANDIDATES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.MATCH_CANDIDATES,
               AI_CANDIDATES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.AI_CANDIDATES,
               RECENT_APPLICATIONS: `${API_ROUTES.INSTITUTES}/job/applications`,
               JOB_APPLICATIONS_ALL: (page: number, limit: number) => 
                   `${API_ROUTES.INSTITUTES}/job/applications?page=${page}&limit=${limit}`,
		SECTORS: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.SECTORS,
		JOB_SKILLS: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.JOB_SKILLS,
		EMPLOYMENT_TYPES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.EMPLOYMENT_TYPES,
		EXPERIENCE: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.EXPERIENCE,
		TRADES: API_ROUTES.INSTITUTES + API_PATHS.INSTITUTES.TRADES,
	},
	EMPLOYER: {
		CATEGORIES: API_ROUTES.INSTITUTES + "/employer-category",
	},
	COURSES: {
		COURSES: API_ROUTES.COURSES,
		EQUIPMENT: (courseId: string) => `${API_ROUTES.COURSES}/${courseId}${API_PATHS.COURSES.EQUIPMENT}`,
	},
	E_CHALLAN_SUMMARY: {
		E_CHALLANS: (type: string) => `${API_PATHS.E_CHALLAN_SUMMARY.E_CHALLANS}?type=${type}`,
	},
	APPLICATIONS: {
		APPLICATIONS: API_ROUTES.APPLICATIONS,
	},
	E_CHALLAN_STATUSES: {
		E_CHALLAN_STATUS: (type: string, page: number) =>
			`${API_PATHS.E_CHALLAN_STATUS.E_CHALLAN_STATUS}?type=${type}&page=${page}`,
	},
	TRACK_APPLICATIONS: {
		TRACK_APPLICATIONS: (status: string) => `${API_ROUTES.APPLICATIONS}/${status}`,
	},
	NOTIFICATIONS: {
		NOTIFICATIONS: API_ROUTES.NOTIFICATIONS,
		READ: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${id}${API_PATHS.NOTIFICATIONS.READ}`,
		STREAM: (id: string) => `${API_ROUTES.NOTIFICATIONS}/${API_PATHS.NOTIFICATIONS.STREAM.replace("{id}", id)}`,
	},
} as const;

export const QUERY_KEYS = {
	USER: {
		PROFILE_IMAGE_UPDATE: "profile-image-update",
		PROFILE_UPDATE: "profile-update",
		GET_PROFILE: "profile",
	},
	COURSES: {
		COURSES: "courses",
		EQUIPMENT: "course-equipment",
	},
	E_CHALLAN_SUMMARY: {
		E_CHALLANS: "e-challan-summary",
	},
	APPLICATIONS: {
		APPLICATIONS: "applications",
	},
	E_CHALLAN_STATUSES: {
		E_CHALLAN_STATUS: "e-challan-status",
	},
	TRACK_APPLICATIONS: {
		TRACK_APPLICATIONS: "track-applications",
	},
	INSTITUTES: {
		ORGANIZATION_TYPE: "organization-types",
		PROVINCE: "provinces",
		DIVISION: "divisions",
		DISTRICT: "districts",
		CITY: "cities",
		TEHSIL: "tehsils",
		UNION_COUNCIL: "union-councils",
		NATIONAL_ASSEMBLY: "national-assemblies",
		PROVISIONAL_ASSEMBLY: "provisional-assemblies",
		FACILITY_TYPES: "facility-types",
		ATTACHMENT_TYPES: "attachment-types",
		COURSE_STREAM: "course-stream",
		COURSE_LIST: "course-list",
		QUALIFICATION: "qualification",
		DESIGNATION: "designation",
		COURSE_LABS: "course-labs",
		ATTACHMENT_UPLOAD: "attachment-upload",
		APPLICATION_COURSE: "application-course",
               JOB_CREATE: "job-create",
               JOB_DETAIL: "job-detail",
               JOB_APPLICATIONS: "job-applications",
               APPLICATION_DETAIL: "application-detail",
               EMPLOYEE_DETAIL: "employee-detail",
               RECENT_APPLICATIONS: "recent-applications",
               JOB_APPLICATIONS_ALL: "job-applications-all",
               JOB_CATEGORIES: "job-categories",
               MATCH_CANDIDATES: "match-candidates",
               AI_CANDIDATES: "ai-candidates",
		SECTORS: "sectors",
		JOB_SKILLS: "skill",
		EMPLOYMENT_TYPES: "employment-types",
		EXPERIENCE: "experience",
		TRADES: "trades",
	},
	EMPLOYER: {
		CATEGORIES: "employer-categories",
	},
};

export const QUERY_PARAMS = {};

export const AUTH_ENDPOINTS = [
	SERVER_ROUTES.AUTH.SIGN_IN,
	SERVER_ROUTES.AUTH.SIGN_UP,
	SERVER_ROUTES.AUTH.FORGOT_PASSWORD,
	SERVER_ROUTES.AUTH.RESET_PASSWORD,
	SERVER_ROUTES.AUTH.SET_PASSWORD,
	SERVER_ROUTES.AUTH.VERIFY_OTP,
	SERVER_ROUTES.AUTH.RESEND_OTP,
	SERVER_ROUTES.AUTH.VERIFY_EMAIL,
];